import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { initMCARS080EntrySearchHistoryInfoOutDto, MCARS080EntrySearchHistoryInfoOutDto } from "pages/MCARS080/apiConfig"
import { MCAXS010RegistSearchHistoryRequest } from "types/MCAXS010/MCAXS010RegistSearchHistoryRequest"

interface InitialState {
  openMCARS080: boolean
  searchHistoryInfo: MCARS080EntrySearchHistoryInfoOutDto
}

const initialState: InitialState = {
  openMCARS080: false,
  searchHistoryInfo: initMCARS080EntrySearchHistoryInfoOutDto,
}

const entrySearchHistorySlice = createSlice({
  name: 'entrySearchHistory',
  initialState,
  reducers: {
    // 初期表示 リクエスト
    getMcars080Init(state) {
      return state;
    },
    // 初期表示 レスポンス結果をセット
    setMcars080Init(state, action: PayloadAction<MCARS080EntrySearchHistoryInfoOutDto>) {
      state.searchHistoryInfo = action.payload;
      return state;
    },
    // 「検索」押下時、検索履歴を設定
    registSearchHistory(state, action: PayloadAction<MCAXS010RegistSearchHistoryRequest>){
      return state;
    },
    setOpenMCARS080(state, action: PayloadAction<boolean>) {
      state.openMCARS080 = action.payload;
      return state;
    },
  },
})

export const {
  getMcars080Init,
  setMcars080Init,
  registSearchHistory,
  setOpenMCARS080,
} = entrySearchHistorySlice.actions
export default entrySearchHistorySlice.reducer
